<template>
  <v-flex justify="center">
    <div>
      <v-card
        class="mx-auto"
       
        max-width="1000"
        min-width="300"
      >
        <v-toolbar class="pencil" :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1"
              >arrow_downward</v-icon
            >
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>

        <v-expand-transition>
          <div v-if="Hide">
            <div  v-if="feedback.length != 0">
                <v-expansion-panel
              
                v-model="panelIndex"
              >
                <v-expansion-panel-content   v-for="(item, i) in feedback"
                :key="i">
                  <template v-slot:header>
                    <div>
                      <p class="headline text--primary">
                        {{ item.name }}
                      </p>
                      <p class="text-lg-right">
                        Givare av återkoppling:
                        {{
                          item.hasOwnProperty("feedbackGiver")
                            ? locfun.getName(
                                item.feedbackGiver,
                                [],
                                membernameandId
                              )
                            : " okänd"
                        }}
                        {{ locfun.getDate(item.feedbackTime) }}
                      </p>
                    </div>
                  </template>
                  <v-card class="grey lighten-5">
                    <v-card-text> {{ item.feedback }} </v-card-text>
                    <v-card-actions>
                       <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                      <v-btn
                      v-if="item.hasOwnProperty('feedbackReceiver')"
                        class="mx-2 blue"
                        fab
                        dark
                        small
                        @click="sendFeedback(item, -1)"
                        color="red ligthen-1"
                         v-bind="attrs"
                  v-on="on"
                      >
                        <v-icon dark :color="SetColor(item,-1)"> thumb_down </v-icon>
                      </v-btn>

              </template>
              <span>Återkoppling fungerar ej</span>
            </v-tooltip>
                       <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                      <v-btn
                      
                      v-if="item.hasOwnProperty('feedbackReceiver')"
                        class="mx-2"
                        fab
                        dark
                        small
                        @click="sendFeedback(item, 1)"
                        color="green ligthen-1"
                         v-bind="attrs"
                  v-on="on"
                      >
                        <v-icon dark :color="SetColor(item,1)"> thumb_up </v-icon>
                      </v-btn>

                      
              </template>       
                     <span>Återkoppling fungerar</span>
            </v-tooltip>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
      <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-2 text-center'">  
    <span class="tt" color="white">Det finns ingen återkoppling just nu.</span>
    </div>
          </div>
        </v-expand-transition>
      </v-card>
    </div>
  </v-flex>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
import fun from "../functions";
export default {
  name: "feedback",
  props: {
    teacherId:String,
    Headline: String,
    // Content: Array,
    ToolColor: String,
  },
  watch: {
  panelIndex: function() {
    if (this.panelIndex!=null) {
      let item= this.feedback[this.panelIndex]
       let thisTeacher= null;
      if (!item.hasOwnProperty('feedbackReceiver')) {
          item.feedbackReceiver=[]
      }
      else
       thisTeacher= item.feedbackReceiver.find(x=> x.id== this.teacherId)
        if (thisTeacher==null) {
          let Feedback={id: this.teacherId,
opened: Date.now() ,
opinion: 0,
}
item.feedbackReceiver.push(Feedback)
          this.UpdateCase([item])
        }
      }
  },
  },
  computed: {
    ...mapGetters("teachers", ["teachernameandId"]),
    ...mapGetters('classesAP', ['classes']),
    ...mapGetters('teachers', ['feedback', 'casesFetched']),
    ...mapGetters("ehtmembers", ["membernameandId"]),
  },
  created() {
    this.locfun = new fun();
},
  methods: {
          ...mapActions("cases", [
      "UpdateCase" 
    ]), 

    ...mapActions('teachers', ['initcases']),
    Loadin()
    {
       if (this.casesFetched==false) {
          
      if(this.classes.length!=0)   
      {
          //console.log("Fetched"); 
      this.initcases(this.classes)

      }
}  
    },

SetColor(item,opinion){
  let id= item.feedbackReceiver.find(f=> f.id ==this.teacherId)
  if (id!=null ) {
   if (id.opinion== opinion) {
     return 'amber accent-3';
   }
   
   
  }
  
   return ''


},

sendFeedback(Case,updown){

       let thisTeacher={id: this.teacherId,
opened: Date.now() ,
opinion: updown,
}
Case.feedbackReceiver = Case.feedbackReceiver.flat()
if (Case.feedbackReceiver.length!=0) {
let place=  Case.feedbackReceiver.findIndex(o=> o.id === thisTeacher.id)
if (place !=-1) {
Case.feedbackReceiver[place] = thisTeacher
  
}
else
  Case.feedbackReceiver.push(thisTeacher)

}
else
{
  Case.feedbackReceiver.push(thisTeacher)
}

          this.UpdateCase([Case])
}
  },
  data() {
    return {
       panelIndex: -9,
      Hide: false,
      colors: [{prime: 'light-blue lighten-3', second: 'light-blue lighten-4'},
      {prime: 'yellow lighten-2', second: 'yellow lighten-3'},
      {prime: 'deep-orange lighten-1', second: 'deep-orange lighten-2'}],
      panel: [],
        items: 5,
   
    };
  },
};
</script>

<style >
.padd {
  padding: 5px;
}
</style>